module.exports = __webpack_public_path__ + "img/favorito.a12f82b9.svg";